module.exports = __webpack_public_path__ + "static/media/imac.adff27a1.png";


//////////////////
// WEBPACK FOOTER
// ./src/semantic/dist/themes/fibrestream/assets/images/imac.png
// module id = 1058
// module chunks = 0